import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
/**
 * @hidden
 */
var VirtualItem = (function () {
    function VirtualItem(templateRef, viewContainer) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
    }
    VirtualItem.decorators = [
        { type: Directive, args: [{ selector: '[virtualItem]' },] },
    ];
    /** @nocollapse */
    VirtualItem.ctorParameters = function () { return [
        { type: TemplateRef, },
        { type: ViewContainerRef, },
    ]; };
    return VirtualItem;
}());
export { VirtualItem };
//# sourceMappingURL=virtual-item.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ionic-angular/components/virtual-scroll/virtual-item.js
// module id = 99
// module chunks = 1